import React, { useState } from 'react';
import { useToasts } from 'react-toast-notifications';
import { Button } from 'reactstrap';
import { Field } from '@galop/component-library';

export const InviteUser = (props) => {
    const { Close, AppName, CurrentUserName, HideHeader, InvitedUser } = props;
    const { addToast } = useToasts();
    const [inviteEmail, setInviteEmail] = useState('');

    const inviteUser = () => {
        addToast('Setting up invite email', { appearance: 'info', autoDismiss: true });
        let body = `Welcome%20to%20${AppName}!%20${!props.children ? 'Register%20at%20' : ''}${window.location.origin}`;
        if (CurrentUserName) {
            body = `${CurrentUserName}%20has%20invited%20you%20to%20${AppName}.%20${!props.children ? 'Register%20at%20' : ''}${window.location.origin}.`;
        }

        window.location.href = `mailto:${inviteEmail}?subject=Welcome%20to%20${AppName}!&body=${body}`;

        Close();
        if (InvitedUser && typeof InvitedUser === 'function') {
            InvitedUser(inviteEmail);
        }
    };

    return (
        <div className={props.className}>
            {!HideHeader && <h4 className="text-dark">Invite a New User</h4>}
            <Field className="mb-2" field="email" label="Email" value={inviteEmail} onChange={(e) => setInviteEmail(e.target.value)} HideHelp />
            {props.children}
            <div className="py-2 text-end">
                <Button color="light" className="border me-1" onClick={Close} style={{ marginRight: 3 }}>Close</Button>
                <Button color="secondary" disabled={!inviteEmail} onClick={inviteUser}>Invite User</Button>
            </div>
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/components/Users/InviteUser.js